import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginRouteService {
  constructor(private router: Router) { }

  redirectToLogin(): Observable<any> {
    if (window.location.port === '50168')
      this.router.navigate(['/identity/login']);
    else
      window.location.href = '/identity/login';

    return EMPTY;
  }

  redirectToLogin$(): Observable<boolean | UrlTree> {
    if (window.location.port === '50168')
      return of(this.router.createUrlTree(['/identity/login']));
    else
      window.location.href = '/identity/login';

    return of(false);
  }
}
